import { createFileRoute } from '@tanstack/react-router'
import AssetLens from 'pages/assetLens/AssetLens'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

import { SEARCH_PARAM_ASSET_LENS_TAB } from './-searchParams'

const searchSchema = z.object({
  [SEARCH_PARAM_ASSET_LENS_TAB]: z.string().optional(),
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_UNIT_ID]: z.string(),
})

const RouteComponent = () => {
  const { tab, siteId, unitId } = Route.useSearch()

  return <AssetLens tab={tab} siteID={siteId} unitID={unitId} />
}

export const Route = createFileRoute('/asset-lens/')({
  component: RouteComponent,
  staticData: {
    title: 'Asset Lens',
  },
  validateSearch: searchSchema,
})
